import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

const SUPPORTED_LANGS = new Set(['fr', 'en', 'de', 'es', 'it', 'pt', 'nl']);

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private readonly translate = inject(TranslateService);
  private currentLang = 'fr';

  get lang(): string {
    return this.currentLang;
  }

  initFromProfile(langCode?: string | null): Observable<unknown> {
    return this.setLanguage(langCode ?? 'fr');
  }

  setLanguage(langCode: string): Observable<unknown> {
    const normalized = this.normalizeLangCode(langCode);
    const activeLang = normalized === 'en' ? 'en' : 'fr';

    return this.translate.use(activeLang).pipe(
      tap(() => {
        this.currentLang = activeLang;
        if (typeof document !== 'undefined') {
          document.documentElement.lang = activeLang;
        }
      }),
      catchError(() => {
        this.currentLang = 'fr';
        if (typeof document !== 'undefined') {
          document.documentElement.lang = 'fr';
        }
        return of({});
      }),
    );
  }

  instant(key: string, params?: Record<string, unknown>): string {
    return this.translate.instant(key, params);
  }

  normalizeLangCode(langCode: string): string {
    const code = (langCode ?? 'fr').toLowerCase();
    return SUPPORTED_LANGS.has(code) ? code : 'fr';
  }
}
